import { Component, OnInit, ViewChild } from '@angular/core';
import { FiltroRelatorioLotes } from '../filter/filtro-relatorio-lotes';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoModalAction, PoModalComponent, PoPageFilter, PoSearchFilterMode, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { Router } from '@angular/router';
import { RomaneioService } from '../service/romaneio.service';
import { PoStorageService } from '@po-ui/ng-storage';
import { ExcelService } from 'src/app/service/excel-service';

@Component({
  selector: 'app-relatorio-lotes',
  templateUrl: './relatorio-lotes.component.html',
  styleUrls: ['./relatorio-lotes.component.css']
})
export class RelatorioLotesComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRelatorioLotes;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  varOrigem: Array<PoSelectOption>;
  varStatus: Array<PoSelectOption>;

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poStorageService: PoStorageService,
    private excelService: ExcelService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroRelatorioLotes(this.poStorageService);

    this.varOrigem = this.listaOrigem();
    this.varStatus = this.listaStatus();
  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.romaneioService.listaRelatorioLotes(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items;
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CZ02LOTE'   , label: 'Lote'       , width: '7%'},
    {property: 'NZ02PESO'   , label: 'Peso'       , width: '7%'},
    {property: 'CZ02PRAT'   , label: 'Prateleira' , width: '7%'},
    {property: 'CZ02STATUS', label: 'Status'      , width: '17%', type: 'label',
      labels: [
        { value: 'F', color: 'color-08',  label: 'Sem saldo no CD'},
        { value: 'T', color: 'color-01',  label: 'Inativo por Troca de Pedido'},
        { value: 'D', color: 'color-05',  label: 'Reenviado para SOLIDA'},
        { value: 'P', color: 'color-12',  label: 'Recebido no CD'},
        { value: 'L', color: 'color-03',  label: 'N/D'},
      ]
    },
    {property: 'CZ02PEDIDO' , label: 'Ped. Origem', width: '8%'},
    {property: 'CZ02PEDDES' , label: 'Ped. Destino', width: '8%'},
    {property: 'NZ02NPACOT' , label: 'Nro Pacote' , width: '7%'},
    {property: 'CZ02INFORM' , label: 'Esqui/Toco' , width: '8%'},
    {property: 'CZ02UR'     , label: 'UR'         , width: '7%'},
    {property: 'NZ02VOLUME' , label: 'Volume'     , width: '7%'},
    {property: 'NZ02CTNR'   , label: 'Nro Container', width: '7%'},
    {property: 'CEE7PEDIDO' , label: 'PO'         , width: '10%'},
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', action: this.goHome.bind(this) },
      { label: 'Relatório Lotes' }
    ]
  };

  gerarExcel(): void {
    const lista_excel = this.tabelaPrincipalItens.map( (item) => {
      return{
        'Lote'          :  item.CZ02LOTE,
        'Peso'          :  item.NZ02PESO,
        'Pratileira'    :  item.CZ02PRAT,
        'Status'        :  this.getStatusName(item.CZ02STATUS),
        'Pedido Origem' :  item.CZ02PEDIDO,
        'Pedido Destino':  item.CZ02PEDDES,
        'Nro Pacote'    :  item.NZ02NPACOT,
        'Inform.'       :  item.CZ02INFORM,
        'UR'            :  item.CZ02UR,
        'Volume'        :  item.NZ02VOLUME,
        'Nro Container' :  item.NZ02CTNR,
        'PO'            :  item.CEE7PEDIDO,
      }
    });

    this.excelService.exportAsExcelFile(lista_excel, `Relatório Lotes`);
  }

  listaOrigem(): Array<PoSelectOption> {
    return [
        { value: "SO", label: "Solida - Baldeio"    },
        { value: "BA", label: "CD Solida" },
    ];
  }

  listaStatus(): Array<PoSelectOption> {
    return [
      { value: "A", label: "Pendente Confirmação" },
      { value: "0", label: "Pendente Envio"       },
      { value: "1", label: "Pendente Recebimento" },
      { value: "Z", label: "Recebido"             },
    ];
  }

  getStatusName(cStatus: String) {
    if (cStatus == 'F') {
      return 'Sem saldo no CD';
    } else if (cStatus == 'T') {
      return 'Inativo por Troca de Pedido';
    } else if (cStatus == 'D') {
      return 'Reenviado para SOLIDA';
    } else if (cStatus == 'P') {
      return 'Recebido no CD';
    } else {
      return 'N/D';
    }
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
